import Api from "../../api/Api";
import { toast } from "react-toastify";
import {
  GET_APPLESMSLINK_SUCCESS,
  UPDATE_APPLESMSLINK_SUCCESS,
} from "./actionTypes";

const getListParams = (params, state) => ({
  page: params.page ?? state?.pagination?.page ?? 1,
  per_page: params.per_page ?? state?.pagination?.per_page ?? 10,
  search: params.search ?? state?.pagination?.search ?? "",
  silent: params.silent ?? false,
});

const getResponseBody = (response) => response?.data ?? response;

const toList = (value) => (Array.isArray(value) ? value : []);

const buildSuccessPayload = (response, { search }) => {
  const data = getResponseBody(response);
  const items = toList(data.data);

  return {
    applesmslink: items,
    total: data.total ?? items.length,
    page: data.page ?? 1,
    per_page: data.per_page ?? 10,
    search,
  };
};

const reloadList = (dispatch, getState, overrides = {}) => {
  const { pagination } = getState().APPLESMSLINK;
  dispatch(
    loadAppleSMSLink({
      page: pagination?.page ?? 1,
      per_page: pagination?.per_page ?? 10,
      search: pagination?.search ?? "",
      silent: true,
      ...overrides,
    })
  );
};

export const loadAppleSMSLink = (params = {}) => (dispatch, getState) => {
  const listState = getState().APPLESMSLINK;
  const { page, per_page, search, silent } = getListParams(params, listState);

  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;

  const req = Api.get("/applesmslinkall/get", {
    params: { page, per_page, search },
  });

  const onSuccess = (data) => {
    dispatch({
      payload: buildSuccessPayload(data, { search }),
      type: GET_APPLESMSLINK_SUCCESS,
    });
  };

  if (silent) {
    req.then((response) => onSuccess(response)).catch(() => {});
    return;
  }

  toast.promise(req, {
    pending: "Getting Apple SMS Link IDs...",
    success: {
      render({ data: response }) {
        onSuccess(response);
        return "Your Data Is Ready";
      },
    },
    error: {
      render() {
        return "An error occurred while getting Apple SMS Link IDs";
      },
    },
  });
};

export const addAppleSMSLink = (data) => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  let req = Api.post("/applesmslink/add", data);

  toast.promise(req, {
    pending: "Loading...",
    success: {
      render() {
        reloadList(dispatch, getState, { page: 1 });
        return "Apple SMS Link added successfully";
      },
    },
    error: {
      render({ data }) {
        return data?.response.data?.message;
      },
    },
  });
};

export const updateAppleSMSLink = (data) => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  let req = Api.post("/applesmslink/update", data);

  toast.promise(req, {
    pending: "Loading...",
    success: {
      render({ data }) {
        dispatch({
          payload: data.data.data,
          type: UPDATE_APPLESMSLINK_SUCCESS,
        });
        reloadList(dispatch, getState);
        return "Apple SMS Link updated successfully";
      },
    },
    error: {
      render() {
        return "An error occurred while updating your Apple SMS Link";
      },
    },
  });
};

export const deleteAppleSMSLink = (data) => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  let req = Api.post("/applesmslink/delete", data);

  toast.promise(req, {
    pending: "Loading...",
    success: {
      render() {
        reloadList(dispatch, getState);
        return "Apple SMS Link deleted successfully";
      },
    },
    error: {
      render() {
        return "An error occurred while deleting your Apple SMS Link";
      },
    },
  });
};

export const importAppleSMSLink = (data) => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  Api.defaults.headers.common["Content-Type"] = "multipart/form-data";
  let req = Api.post("/applesmslink/import", data);

  toast.promise(req, {
    pending: "Loading...",
    success: {
      render() {
        reloadList(dispatch, getState, { page: 1, search: "" });
        return "Apple SMS Links imported successfully";
      },
    },
    error: {
      render({ data }) {
        return data?.response.data?.message;
      },
    },
  });
};
